import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

// const defaultSize = 24;
const defaultHeight = 37;
const defaultWidth = 34;

export default ({
  color = defaultIconColor,
  height = defaultHeight,
  width = defaultWidth,
  backgroundColor = '#ffffff',
  ...props
}: SVGComponentPropsType & { backgroundColor? }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox={`0 0 ${defaultWidth} ${defaultHeight}`}
    fill="none"
    {...props}
  >
    <path d="M3 26V13l14.0001-8 14 8v13l-14 8-14-8Z" fill={color} fillOpacity=".1" stroke={color} strokeWidth="2" />
    <circle cx="31" cy="13" r="2" fill={backgroundColor} stroke={color} strokeWidth="2" />
    <circle cx="31" cy="26" r="2" fill={backgroundColor} stroke={color} strokeWidth="2" />
    <circle cx="17" cy="34" r="2" fill={backgroundColor} stroke={color} strokeWidth="2" />
    <circle cx="3.0001" cy="26" r="2" fill={backgroundColor} stroke={color} strokeWidth="2" />
    <circle
      cx="3.1008"
      cy="13.1007"
      r="2"
      transform="rotate(2.964 3.1008 13.1007)"
      fill={backgroundColor}
      stroke={color}
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m17 20-5-7c-2.5-4 .6061-9 5-9s7.5 5 5 9l-5 7Z"
      fill={backgroundColor}
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="17.0001" cy="10" r="2" stroke={color} strokeWidth="2" />
  </svg>
);
